import React, { useEffect } from 'react';
import { Card, Container, Row, Col, Button, Navbar } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowRight, ArrowLeft } from 'react-bootstrap-icons';
import logo from './Cavinkare_Logo_Updated.png';
import AOS from 'aos';
import 'aos/dist/aos.css';

const links = {
    HR: [
      { name: 'CLR Application', url: 'https://hrmisprd.ckdigital.in/' },
      { name: 'CLMS', url: 'https://clms.ckdigital.in/' },
      {name: 'Cavinhub - Darwinbox', url: 'https://cavinhub.darwinbox.in'},
      {name:'Savior Time Office', url:'https://tos.cavinkare.in:85/frmLogin.aspx'},
      {name:'Goal Sync', url:'https://goalsync.in/'},
      {name:'Peoplebox', url:'https://dashboard.peoplebox.ai/'}
    ],
    Production: [
      { name: 'Digital Forms', url: 'https://oeeprd.ckdigital.in/'},
      { name: 'OEE Portal(Prodmax)', url: 'https://prodmaxuat.ckdigital.in/login'},
      {name: 'Mass Balance', url: 'https://mbsprd.ckdigital.in/login.html'},
      {name:'DRM - KPI', url: 'https://drm.ckdigital.in/'},
    ],
    Quality: [
      { name: 'Batch Coding Verification', url: 'https://oeeprd.ckdigital.in/'},
      { name: 'QA Log Books', url: 'https://ckplsf.ckdigital.in/login.html'}
    ],
    Maintenance: [
      { name: 'Maintenance Order Creation', url: 'https://bkappprd.ckdigital.in/'},
      { name: 'Preventive Maintenance', url: 'https://bkappprd.ckdigital.in/'},
      { name: 'EMS', url: 'http://ems.cavinkare.in/'},
    ],
    Utility: [
      { name: 'Boiler and Electrical Log Book', url: 'https://ckplsf.ckdigital.in/login.html'},
    ],
    IT: [
      {name: 'CK Assets', url:'https://ckassets.cavinkare.in/'},
      {name: 'Email', url:'https://outlook.office365.com/mail/'},
      {name: 'One Drive', url:'https://cavinkare-my.sharepoint.com/'},
    ],
    Safety: [
      { name: 'Nataional Safety Council', url: 'https://connect.nsc.org.in/'},
      { name: 'Work Permit Dashboard', url: 'https://oeeprd.ckdigital.in/'},
      { name: 'Safety CheckList', url: 'https://oeeprd.ckdigital.in/'},
    ],
    Gate: [
      {name: 'Happy Visitor', url: 'https://vms.cavinkare.in:8443/visitor_management/login'},
      {name: 'Gate Smart Apps', url:'https://traceprd.ckdigital.in/index.html'},
      {name: 'Vehicle Report', url:'https://mbsprd.ckdigital.in/login.html'}
    ],
    TicketingTool: [
      {name: 'CK Ticketing Tool', url: 'http://helpdesk.cavinkare.in'},
    ],
    VirtualAudit: [
      {name: 'Virtual Audit', url: 'https://vaaudit.ckplprojects.com/'},
    ],
    Compliance: [
      {name: 'Ground Water E&E Solution', url: 'http://customer.enggenv.com'},
      {name: 'Legal HR Software', url: 'https://cavinkare.komrisk.com/komrisk/'},
    ],
    Tetrapak: [
      {name: 'Tetrapak Log Book', url:'https://cavins.ckdigital.in:5001/'}
    ],
    Finance: [
      {name: 'I View', url:'https://iviewplant.cavinkare.in/index.php/login'},
      {name: 'Paysoft', url: 'http://52.172.10.153/CkpaysoftApp/Views/loginpage'},
      {name: 'New I View', url: 'https://newiviewplant.cavinkare.in/login'}
    ],
    Logistics:[
        {name: 'Logistics Dashboard', url: 'https://cavins.ckdigital.in:3000/d/cf9mz6mrlp3pcf/logistic-dashboard-erode-updated?orgId=18'}
    ]
  };

const DetailPage = () => {
    const navigate = useNavigate();
    const { category } = useParams();
    const categoryLinks = links[category];

    useEffect(() => {
      AOS.init({
        duration: 1200, 
        once: true,    
      });
    }, []);

  return (
    <div className="details-page">
      <Navbar variant="light" expand="lg" className="justify-content-between">
        <Navbar.Brand className="d-flex align-items-center">
        <Col xl={4} md={4} sm={12} lg={4}> <img
            height={65}
            src={logo}
            className="d-inline-block align-top"
            alt="Logo"
          />
          </Col>
          <Col className="d-flex justify-content-center" xl={4} md={4} sm={12} lg={4}>
          <h3 className="mb-0 mx-auto">CK Erode Digital Hub</h3>
          </Col>
          <Col className="d-flex justify-content-end" xl={4} md={4} sm={12} lg={4}>
          </Col>
        </Navbar.Brand>
      </Navbar>

      <Container className="mt-2">
        <Button onClick={() => navigate('/')}><ArrowLeft /> Back</Button>
        <div className="text-center mt-1 mb-3">
          <h3>{category}</h3>
        </div>
        <Row className="mt-4 justify-content-center">
          {categoryLinks.map((link, index) => (
            <Col key={index} xs={12} md={4} className="mb-4">
              <Card 
                onClick={() => window.open(link.url, '_blank')}
                data-aos="zoom-in-up" 
              >
                <Card.Body style={{ cursor: 'pointer' }}>
                  <Card.Title>{link.name}</Card.Title>
                  <ArrowRight className="float-right text-primary" style={{ fontSize: '1.5rem' }} />
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  )
}

export default DetailPage